var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"mx-1 mb-2 pt-5 px-2 md2-border",attrs:{"dense":""}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }